// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".delete-solidity-contract-dialog[data-v-2cb07b2c] .el-dialog{width:var(--common-dialog-medium-width)}.delete-solidity-contract-dialog .hint[data-v-2cb07b2c]{padding:var(--base-size-8) var(--base-size-16);margin-bottom:var(--base-size-20)}", ""]);
// Exports
module.exports = exports;
